import React from 'react';
import { useState, useEffect } from 'react';
import { Icon, Collapse } from 'antd';
import {
  BatchInfo,
  DateFilter,
  FilterTitle,
  FilterData,
  TagsData,
  Tags,
} from './batchFiltersStyles';
import { dateTimeConversion } from '../../utils/javascript';
import { withTranslation } from 'react-i18next';
import { BATCH_APPLIED_FILTER } from './translationValues';

const NAMESPACES = ['BATCH_APPLIED_FILTER'];
const { Panel } = Collapse;

const BatchFilters = props => {
  const [tagDetails, setTagDetails] = useState([]);
  const { filterSection, setFilterSection, batchData, getTagDetails, t } = props;

  useEffect(() => {
    if (batchData.tag1 || batchData.tag2 || batchData.tag3 || batchData.tag4) {
      let tagsDetail = getTagDetails(batchData).filter(item => item.tagValue !== null);
      setTagDetails(tagsDetail);
    }
  }, []);
  return (
    <BatchInfo filterSection={filterSection}>
      <div className="filtersButton" onClick={() => setFilterSection(!filterSection)}>
        {t(BATCH_APPLIED_FILTER.APPLIED_FILTER_TITLE.key, BATCH_APPLIED_FILTER.APPLIED_FILTER_TITLE.value)}
        <Icon type="caret-right" />
      </div>
      <div className="filtersInfo">
        {batchData.description && (
          <DateFilter>
            <FilterData>{batchData.description}</FilterData>
          </DateFilter>
        )}
        <DateFilter>
          <>
            <Icon type="calendar" />
            <FilterTitle> {t(BATCH_APPLIED_FILTER.FROM_DATE_LABEL.key, BATCH_APPLIED_FILTER.FROM_DATE_LABEL.value)}</FilterTitle>
          </>
          <FilterData>{dateTimeConversion(batchData.dateFrom, true, true, false)}</FilterData>
        </DateFilter>
        <DateFilter>
          <>
            <Icon type="calendar" />
            <FilterTitle>{t(BATCH_APPLIED_FILTER.TO_DATE_LABEL.key, BATCH_APPLIED_FILTER.TO_DATE_LABEL.value)}</FilterTitle>
          </>
          <FilterData>{dateTimeConversion(batchData.dateTo, true, true, false)}</FilterData>
        </DateFilter>
        <DateFilter>
          <>
            <Icon type="printer" />
            <FilterTitle> {t(BATCH_APPLIED_FILTER.SELECT_PRINTER_LABEL.key, BATCH_APPLIED_FILTER.SELECT_PRINTER_LABEL.value)}</FilterTitle>
          </>
          <FilterData>{batchData.printerName}</FilterData>
        </DateFilter>
        {batchData.nameSearched && (
          <DateFilter>
            <>
              <Icon type="search" />
              <FilterTitle> {t(BATCH_APPLIED_FILTER.SEARCH_LABEL.key, BATCH_APPLIED_FILTER.SEARCH_LABEL.value)}</FilterTitle>
            </>
            <FilterData>{batchData.nameSearched}</FilterData>
          </DateFilter>
        )}
        {batchData.documentPages && (
          <DateFilter>
            <>
            <Icon type="file" />
            <FilterTitle> {t(BATCH_APPLIED_FILTER.PAGES_LABEL.key, BATCH_APPLIED_FILTER.PAGES_LABEL.value)}</FilterTitle>
            </>
            <FilterData>{batchData.documentPages}</FilterData>
          </DateFilter>
        )}
        <DateFilter>
          <>
            <Icon type="copy" />
            <FilterTitle> {t(BATCH_APPLIED_FILTER.NUMBER_OF_FILES_LABEL.key, BATCH_APPLIED_FILTER.NUMBER_OF_FILES_LABEL.value)}</FilterTitle>
          </>
          <FilterData>
            {batchData.failedCount + batchData.successCount + batchData.inqueueCount}
          </FilterData>
        </DateFilter>
        {(batchData.tag1 || batchData.tag2 || batchData.tag3 || batchData.tag4) && (
          <DateFilter isTag={1}>
            <>
              <Icon type="tag" />
              <FilterTitle>   {t(BATCH_APPLIED_FILTER.TAG_LABEL.key, BATCH_APPLIED_FILTER.TAG_LABEL.value)}</FilterTitle>
            </>
            <Collapse
              bordered={false}
              defaultActiveKey={[]}
              expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
            >
              {tagDetails?.map((item, key) => {
                return (
                  <Panel header={item.tagName} key={key}>
                    <TagsData>
                      {item.tagValue?.split(',').map((li, index) => {
                        return <Tags key={index}>{li}</Tags>;
                      })}
                    </TagsData>
                  </Panel>
                );
              })}
            </Collapse>
          </DateFilter>
        )}
      </div>
    </BatchInfo>
  );
};
export default withTranslation(NAMESPACES)(BatchFilters);

